import { QuestionnaireSectionDetailProps } from '@/types/questionnaire';

interface QuestionnaireStepperProps {
  sections: QuestionnaireSectionDetailProps[];
  currentStep: number;
}

export function QuestionnaireStepper({
  sections,
  currentStep,
}: QuestionnaireStepperProps) {
  return (
    <div className="mb-8">
      <div className="flex items-center justify-between w-full gap-2">
        {sections.map((section, index) => {
          const isCompleted = section.section_order < currentStep;
          const isCurrent = section.section_order === currentStep;

          return (
            <div key={section.id} className="relative flex-1">
              <div className="flex flex-col items-center">
                <div
                  className={`w-10 h-10 rounded-full flex items-center justify-center text-sm font-medium transition-all relative z-10 ${
                    isCompleted
                      ? 'bg-green-600 text-white'
                      : isCurrent
                        ? 'bg-primary text-white ring-4 ring-blue-100'
                        : 'bg-gray-300 text-gray-600'
                  }`}
                >
                  {isCompleted ? (
                    <svg
                      className="w-5 h-5"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                    >
                      <path
                        fillRule="evenodd"
                        d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                        clipRule="evenodd"
                      />
                    </svg>
                  ) : (
                    section.section_order
                  )}
                </div>
                <div className="min-h-20 flex flex-col gap-1 items-center text-center text-xs mt-2">
                  <p
                    className={`text-xs font-medium ${
                      isCurrent ? 'text-primary' : 'text-gray-700'
                    }`}
                  >
                    {section.section_name}
                  </p>
                  <p className="text-xs text-gray-500 mt-0.5">
                    {section.questions.length} questions
                  </p>
                </div>
              </div>

              {/* Line positioned absolutely to connect circles */}
              {index < sections.length - 1 && (
                <div className="absolute top-5 left-1/2 w-full h-0.5">
                  <div
                    className={`h-full ${
                      isCompleted ? 'bg-green-600' : 'bg-gray-200'
                    }`}
                  />
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}
